import { reactive, computed } from 'vue'
import { defineStore } from 'pinia'
import { codeIs, mapFromCodesTree } from '@/lib/codes'
import { apiClientV2 } from '@/ContextTab/services/apiClient'
import { EProfileType } from '@/lib/references'
import type { CodeWithCategoryAndChildren, ProfileType } from '@/api/generated/v2'
import type { EProfileTypeValues } from '@/lib/references'


type ProfileCodes = Record<EProfileTypeValues, CodeWithCategoryAndChildren[] | null>

export const useProfileCodesStore = defineStore('profileCodes', () => {

  const profileCodes = reactive<ProfileCodes>({
    PUBLISH_NEWS: null,
    NEWS_OR_ISSUE: null,
    PUBLISH_ISSUE: null,
    DEFAULT: null,
  })

  const newsCreationCodes = computed(() => profileCodes.NEWS_OR_ISSUE)

  const newsPublicationCodes = computed(() => profileCodes.PUBLISH_NEWS)

  const newsPublicationCodesMap = computed(() => mapFromCodesTree(newsPublicationCodes.value))

  const userHasPublicationCodes = computed(() => {
    if (!newsPublicationCodes.value) {
      return false
    }

    // check if user has at least one final non-technical code
    return Object.values(newsPublicationCodesMap.value)
      .some((code) =>
        !codeIs.publicationTechnical(code)
        && code.children.length === 0,
      )
  })

  async function fetchCodeProfile(profileId: ProfileType) {
    const response = await apiClientV2.CodesService.profileCodesCodesProfileGet({
      query: {
        type_id: profileId,
      },
    })

    profileCodes[EProfileType[profileId]] = response.error ? null : response.data

    return response
  }

  return {
    fetchCodeProfile,
    newsCreationCodes,
    newsPublicationCodes,
    userHasPublicationCodes,
  }
})
